import React, { useEffect } from 'react'
import {Toaster, toast} from 'react-hot-toast'

const SimpleToaster = (props) => {

  let failed = props.failed;
  let success = props.success;
  let stateNotification = props.active
  let message =  props.message

  useEffect(() =>{
    if(stateNotification && success) toast.success(message);
    if(stateNotification && failed) toast.error(message);
  }, [message])


  return (
    
    <div> 
      <Toaster toastOptions={{duration: 3000, position: 'top-center', style: {
              border: '1px solid',
              padding: '15px',
              color: success? '#155724' : '#721c24',
              backgroundColor: success ? '#d4edda' : 'f8d7da',
              borderColor: success ? '#c3e6cb': '#f5c6cb'
      }
      }}/>
    </div>
  )
  
}

export default SimpleToaster
